import { Form, Row, Col, Input } from "antd";
import React, { useEffect } from "react";
import BannerCard from "../../../common/components/BannerCard";

const CasePersonDetail = ({ ...props }) => {
  const { form, caseMaster } = props;

  useEffect(() => {
    const paymentData = caseMaster?.balances?.MAIN[0];
    form.setFieldsValue({ ...paymentData });
  }, [caseMaster?.balances?.MAIN, form]);

  return (
    <BannerCard title="Person Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item name="NAME" label="Name">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item name="ADDRESS1" label="Address">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item name="CITY_STATE_ZIP" label="CITY, STATE, ZIP">
              <Input readOnly />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CasePersonDetail;
